export const SHOW_LOADING = 'SHOW_LOADING'

export const SIDE_BAR = 'SIDE_BAR'

export const ALERT_DIALOG  = 'ALERT_DIALOG'
export const ALERT_TITLE   = 'ALERT_TITLE'
export const ALERT_CONTENT = 'ALERT_CONTENT'

export const CONFIRM_DIALOG       = 'CONFIRM_DIALOG'
export const CONFIRM_TITLE        = 'CONFIRM_TITLE'
export const CONFIRM_CONTENT      = 'CONFIRM_CONTENT'
export const CONFIRM_YES_TEXT     = 'CONFIRM_YES_TEXT'
export const CONFIRM_NO_TEXT      = 'CONFIRM_NO_TEXT'
export const CONFIRM_YES_VISIBLE  = 'CONFIRM_YES_VISIBLE'
export const CONFIRM_NO_VISIBLE   = 'CONFIRM_NO_VISIBLE'
export const CONFIRM_YES_CALLBACK = 'CONFIRM_YES_CALLBACK'
export const CONFIRM_NO_CALLBACK  = 'CONFIRM_NO_CALLBACK'

export const TOKN           = 'TOKN'
export const USER_INFO      = 'USER_INFO'
export const USER_NO        = 'USER_NO'
export const USER_NM        = 'USER_NM'
export const CHILDREN       = 'CHILDREN'
export const SELECTED_CHILD = 'SELECTED_CHILD'

export const MAIN_MENU    = 'MAIN_MENU'
export const ENABLE_CHILD = 'ENABLE_CHILD'
export const SCRN_DIV     = 'SCRN_DIV'


export const PAGE_TITLE      = 'PAGE_TITLE'
export const SUB_PAGE_TITLE  = 'SUB_PAGE_TITLE'
export const PAGE_LEFT_DIV   = 'PAGE_LEFT_DIV'
export const PAGE_MID_DIV    = 'PAGE_MID_DIV'
export const PAGE_RIGHT_DIV  = 'PAGE_RIGHT_DIV'
export const ROUTER_DIV      = 'ROUTER_DIV'
export const ROUTER_VAL      = 'ROUTER_VAL'

// userInfo
export const ROLE_CD      = 'ROLE_CD'
export const ROLE_LIST    = 'ROLE_LIST'
export const CMON_CD_LIST = 'CMON_CD_LIST'